import React, { useEffect, useState } from 'react';
import { Card, CardBody, Col, Modal, ModalBody, ModalHeader, Row, Badge, Spinner } from 'reactstrap';
import TestimonialService from '../../../services/KangarooServices/TestimonialService';

const TestimonialDetail = ({ isOpen, toggle, selectedTestimonial }) => {
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState(null);

  const fetchDetail = async () => {
    if (!selectedTestimonial) return;
    setLoading(true);
    try {
      const result = await TestimonialService.getDetail(selectedTestimonial.id);
      setData(result);
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchDetail();
  }, [selectedTestimonial?.id]);

  const renderStars = (rating) =>
    [...Array(5)].map((_, i) => (
      <i
        key={i}
        className={`bi ${i < rating ? 'bi-star-fill text-warning' : 'bi-star text-secondary'}`}
        style={{ marginRight: '2px', fontSize: '1.2rem' }}
      ></i>
    ));

  if (!selectedTestimonial) return null;

  return (
    <Modal isOpen={isOpen} toggle={toggle} size="lg" centered>
      <ModalHeader toggle={toggle} className="border-0">
        <div className="d-flex align-items-center">
            <h5 className="fw-bold text-primary mb-3">Testimonial Information</h5>
          {/* <h5 className="mb-0">{data?.studentName || 'Testimonial Details'}</h5> */}
          
        </div>
      </ModalHeader>

      <ModalBody className="bg-light">
        {loading ? (
          <div className="text-center py-5">
            <Spinner color="primary" />
          </div>
        ) : (
          <Card className="shadow border-0 rounded-4 p-3">
            <Row className="align-items-center">
              {/* Left: Image */}
              <Col md={4} className="text-center mb-3 mb-md-0">
                <div
                  className="rounded-circle overflow-hidden border border-light"
                  style={{ width: '180px', height: '180px', margin: '0 auto', boxShadow: '0 6px 15px rgba(0,0,0,0.1)' }}
                >
                  <img
                    src={data?.studentPhotoId?.url || 'https://via.placeholder.com/180'}
                    // alt={data?.studentName}
                    className="img-fluid"
                    style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                  />
                </div>
              </Col>

              {/* Right: Details */}
              <Col md={8}>
                <InfoRow label="Student Name:"value={data?.studentName} />
                <InfoRow label="Course Name : " value={data?.courseName} />
                <InfoRow label="Destination Country:" value={data?.destinationCountryName} />
                <InfoRow label="University Name:" value={data?.universityName} />
                <InfoRow label="Text:" value={data?.text} />
                <InfoRow label="Rating" value={<div>{renderStars(data?.rating)}</div>} />

                
              </Col>
            </Row>
            <Row>
                {data?.videoUrl && (
                  <div className="mb-2">
                    <label className="text-muted small mb-1">Video</label>
                    <div className="ratio ratio-16x9">
                      <iframe
                        src={convertToEmbedUrl(data.videoUrl)}
                        title="Student Video"
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                        allowFullScreen
                        style={{ borderRadius: '8px' }}
                      ></iframe>
                    </div>
                  </div>
                )}
            </Row>
          </Card>
        )}
      </ModalBody>
    </Modal>
  );
};

// Helper component for consistent info rows
const InfoRow = ({ label, value }) => (
  <div className="mb-2">
    <p className="text-muted small mb-1">{label} </p>
    <p className="fw-semibold mb-0">{value || '-'}</p>
  </div>
);

// Helper function to convert YouTube or Vimeo URL to embed URL
const convertToEmbedUrl = (url) => {
  if (!url) return '';
  // YouTube
  if (url.includes('youtube.com') || url.includes('youtu.be')) {
    const videoId = url.split('v=')[1] || url.split('youtu.be/')[1];
    return `https://www.youtube.com/embed/${videoId.split('&')[0]}`;
  }
  // Vimeo
  if (url.includes('vimeo.com')) {
    const videoId = url.split('/').pop();
    return `https://player.vimeo.com/video/${videoId}`;
  }
  return url; // fallback: return original URL
};

export default TestimonialDetail;
